import { render, staticRenderFns } from "./PanaudaIregistravimas.vue?vue&type=template&id=c59cfb70&scoped=true&"
import script from "./PanaudaIregistravimas.vue?vue&type=script&lang=js&"
export * from "./PanaudaIregistravimas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59cfb70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer})
